import { configureStore } from '@reduxjs/toolkit';
import { createNoopReducer } from './createNoopReducer';
import {
  consultantContactsReducer,
  locationReducer,
  pageStateReducer,
  seoDataReducer,
  userReducer,
  analyticsReducer,
  quizItemsReducer,
  requestFormV2Reducer,
} from '../../slices';
import { IApplicationContext } from '../../types/applicationContext';
import { IInitialApplicationState } from '../../types/redux';
import { TUtm } from '../../types/utm';

/**
 * Хелпер для создания Redux стора
 * @param initialState IInitialApplicationState - предзагруженное состояние
 */
export function createReduxStore(
  initialState: IInitialApplicationState,
  context: IApplicationContext,
  debugEnabled: boolean,
) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    devTools: debugEnabled ? { name: projectName } : false,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    preloadedState: initialState,
    reducer: {
      meta: createNoopReducer<IInitialApplicationState['meta']>(initialState.meta),
      analytics: analyticsReducer,
      consultantContacts: consultantContactsReducer,
      location: locationReducer,
      pageState: pageStateReducer,
      seoData: seoDataReducer,
      user: userReducer,
      requestFormV2: requestFormV2Reducer,
      utm: createNoopReducer<TUtm>(null),
      quizItems: quizItemsReducer,
    },
  });
}
